import React, { useState, useEffect } from 'react';
import { Button } from './ui/button';
import { Badge } from './ui/badge';
import { Card, CardContent, CardHeader, CardTitle } from './ui/card';
import { X, Check } from 'lucide-react';
import { toast } from '../hooks/use-toast';
import { DEFAULT_TAGS } from '../mock';
import { profileAPI } from '../services/api';

const TagSelector = ({ appointment, onClose, onSave }) => {
  const [availableTags, setAvailableTags] = useState([]);
  const [selectedTagIds, setSelectedTagIds] = useState([]);

  useEffect(() => {
    loadTags();
    // Load currently assigned tags
    if (appointment.tags) {
      setSelectedTagIds(appointment.tags);
    }
  }, [appointment]);

  const loadTags = async () => {
    try {
      const response = await profileAPI.get();
      const profileData = response.data;
      const loadedTags = profileData.patientTags || DEFAULT_TAGS;
      setAvailableTags(loadedTags);
    } catch (error) {
      console.error('Error loading tags:', error);
      setAvailableTags(DEFAULT_TAGS);
    }
  };

  const toggleTag = (tagId) => {
    setSelectedTagIds(prev => {
      if (prev.includes(tagId)) {
        return prev.filter(id => id !== tagId);
      } else {
        return [...prev, tagId];
      }
    });
  };

  const handleSave = () => {
    onSave(selectedTagIds);
    toast({
      title: 'Etiquetas actualizadas',
      description: 'Las etiquetas se asignaron correctamente',
    });
    onClose();
  };

  return (
    <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50 p-4">
      <Card className="w-full max-w-md max-h-[80vh] overflow-auto">
        <CardHeader className="flex flex-row items-center justify-between space-y-0 pb-4">
          <CardTitle>Asignar Etiquetas</CardTitle>
          <Button
            variant="ghost"
            size="sm"
            onClick={onClose}
            className="h-8 w-8 p-0"
          >
            <X className="h-4 w-4" />
          </Button>
        </CardHeader>
        <CardContent>
          <div className="mb-4">
            <p className="text-sm text-gray-600 mb-2">
              Paciente: <strong>{appointment.patientName}</strong>
            </p>
            <p className="text-sm text-gray-600">
              Selecciona las etiquetas que deseas asignar:
            </p>
          </div>

          <div className="space-y-2 mb-6">
            {availableTags.length === 0 ? (
              <p className="text-sm text-gray-500 italic">
                No hay etiquetas creadas. Ve a Etiquetas para crear algunas.
              </p>
            ) : (
              availableTags.map(tag => (
                <div
                  key={tag.id}
                  onClick={() => toggleTag(tag.id)}
                  className="flex items-center justify-between p-3 border rounded-lg cursor-pointer hover:bg-gray-50 transition-colors"
                >
                  <div className="flex items-center gap-2">
                    <div
                      className="w-4 h-4 rounded-full"
                      style={{ backgroundColor: tag.color }}
                    />
                    <span className="text-sm font-medium">{tag.name}</span>
                  </div>
                  {selectedTagIds.includes(tag.id) && (
                    <Check className="w-5 h-5 text-blue-600" />
                  )}
                </div>
              ))
            )}
          </div>

          <div className="flex gap-2">
            <Button
              variant="outline"
              onClick={onClose}
              className="flex-1"
            >
              Cancelar
            </Button>
            <Button
              onClick={handleSave}
              className="flex-1"
            >
              Guardar
            </Button>
          </div>
        </CardContent>
      </Card>
    </div>
  );
};

export default TagSelector;
